export default {
    area_covered_by_ir_flight: {
        name: "Area Covered By IR Flight",
        url: "nwcg_polygons_ir/area_covered_by_ir_flight",
    },
    cloud_cover: {
        name: "Cloud Cover",
        url: "nwcg_polygons_ir/cloud_cover",
    },
    ir_intense_heat: {
        name: "IR Intense Heat",
        url: "nwcg_polygons_ir/ir_intense_heat",
    },
    ir_scattered_heat: {
        name: "IR Scattered Heat",
        url: "nwcg_polygons_ir/ir_scattered_heat",
    },
}
